import { render, staticRenderFns } from "./CombinedResultPointAnalysisWidget.vue?vue&type=template&id=ed93f60c"
import script from "./CombinedResultPointAnalysisWidget.vue?vue&type=script&lang=js"
export * from "./CombinedResultPointAnalysisWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed93f60c')) {
      api.createRecord('ed93f60c', component.options)
    } else {
      api.reload('ed93f60c', component.options)
    }
    module.hot.accept("./CombinedResultPointAnalysisWidget.vue?vue&type=template&id=ed93f60c", function () {
      api.rerender('ed93f60c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/components/ExamReport/CombinedResultPointAnalysisWidget.vue"
export default component.exports